import React from 'react';
function Icon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M453.846-413.846h212.308v-92.308H453.846v92.308zm-47.692 47.692v-187.692h307.692v187.692H406.154zM172.309-180.001q-30.308 0-51.308-21t-21-51.308v-455.382q0-30.308 21-51.308t51.308-21h615.382q30.308 0 51.308 21t21 51.308v455.382q0 30.308-21 51.308t-51.308 21H172.309zm0-59.999h615.382q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463V-640H160v387.691q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846z"></path>
    </svg>;
}
export default Icon;